import { QaSiteBanner } from '_atoms';
import { store } from '_store';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import { Provider } from 'react-redux';

import { BrowserRouter } from 'react-router-dom';
import { Main } from './routing';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <HelmetProvider>
        <Provider store={store}>
          <QaSiteBanner />
          <ReactNotifications />
          <Main />
        </Provider>
      </HelmetProvider>
    </BrowserRouter>
  );
};

export default App;
